module.exports = __webpack_public_path__ + "static/media/carousel_analytics_screenshot_4.fc1655fa.png";